import { Component } from '@angular/core';

@Component({
  selector: 'app-gold-brochure',
  templateUrl: './gold-brochure.component.html',
  styleUrls: ['./gold-brochure.component.scss']
})
export class GoldBrochureComponent {

}
